// ======================================================================
// FILE:
// src/modules/expense_management/claims/services/expenseClaimService.js
//
// MODULE:
// Expense Management
//
// FEATURE:
// Expense Claim Service
// ======================================================================

import axiosClient from "../../../../api/axiosClient";

//const BASE_URL = "/expense-management/claims";
//const MASTER_URL =   "/expense-management/masters";

const BASE_URL = "/api/expense-management/claims";
const MASTER_URL = "/api/expense-management/masters";
const APPROVAL_URL = "/api/expense-management/approvals";
const expenseClaimService = {

  // ============================================================
  // LIST
  // ============================================================

  async listExpenseClaims(params = {}) {

    const { data } = await axiosClient.get(
      BASE_URL,
      {
        params,
      }
    );

    return data.data;

  },

  // ============================================================
  // DETAILS
  // ============================================================

  async getExpenseClaim(id) {

    const { data } = await axiosClient.get(
      `${BASE_URL}/${id}`
    );

    return data.data;

  },

  // ============================================================
// CLAIM ITEMS
// ============================================================

async getExpenseClaimItems(id) {

  const { data } = await axiosClient.get(
    `${BASE_URL}/${id}/items`
  );

  return data.data;

},

// ============================================================
// ATTACHMENTS
// ============================================================

async getExpenseAttachments(id) {

  const { data } = await axiosClient.get(
    `${BASE_URL}/${id}/attachments`
  );

  return data.data;

},

// ============================================================
// COMMENTS
// ============================================================

async getExpenseComments(id) {

  const { data } = await axiosClient.get(
    `${BASE_URL}/${id}/comments`
  );

  return data.data;

},

// ============================================================
// HISTORY
// ============================================================

async getExpenseHistory(id) {

  const { data } = await axiosClient.get(
    `${BASE_URL}/${id}/history`
  );

  return data.data;

},
// ============================================================
// APPROVAL TIMELINE
// ============================================================

async getApprovalTimeline(expenseClaimId) {

  const { data } = await axiosClient.get(
    `${APPROVAL_URL}/claim/${expenseClaimId}/timeline`
  );

  return data.data;

},
// ============================================================
// MY PENDING APPROVALS
// ============================================================

async getMyPendingApprovals() {

  const { data } = await axiosClient.get(
    `${APPROVAL_URL}/my-pending`
  );

  return data.data;

},
// ============================================================
// APPROVE EXPENSE
// ============================================================

async approveExpense(
  expenseApprovalId,
  comments = ""
) {

  const { data } = await axiosClient.post(
    `${APPROVAL_URL}/${expenseApprovalId}/approve`,
    {
      comments,
    }
  );

  return data.data;

},
// ============================================================
// REJECT EXPENSE
// ============================================================

async rejectExpense(
  expenseApprovalId,
  comments
) {

  const { data } = await axiosClient.post(
    `${APPROVAL_URL}/${expenseApprovalId}/reject`,
    {
      comments,
    }
  );

  return data.data;

},
// ============================================================
// SEND BACK EXPENSE
// ============================================================

async sendBackExpense(
  expenseApprovalId,
  comments
) {

  const { data } = await axiosClient.post(
    `${APPROVAL_URL}/${expenseApprovalId}/send-back`,
    {
      comments,
    }
  );

  return data.data;

},

  // ============================================================
  // CREATE
  // ============================================================

  async createExpenseClaim(payload) {

    const { data } = await axiosClient.post(
      BASE_URL,
      payload
    );

    return data.data;

  },

  // ============================================================
  // UPDATE
  // ============================================================

  async updateExpenseClaim(
    id,
    payload
  ) {

    const { data } = await axiosClient.put(
      `${BASE_URL}/${id}`,
      payload
    );

    return data.data;

  },

  // ============================================================
  // DELETE
  // ============================================================

  async deleteExpenseClaim(id) {

    const { data } = await axiosClient.delete(
      `${BASE_URL}/${id}`
    );

    return data.data;

  },

  // ============================================================
  // SUBMIT
  // ============================================================

  async submitExpenseClaim(id) {

    const { data } = await axiosClient.post(
    `${BASE_URL}/${id}/submit`,
    {}
  );

  return data.data;

},

async getExpensePolicies() {

  const { data } = await axiosClient.get(
    `${MASTER_URL}/expense-policies`
  );

  return data.data.data;

},
// ============================================================
// CURRENCIES
// ============================================================

async getCurrencies() {

  const { data } = await axiosClient.get(
    `${MASTER_URL}/currencies`
  );

  return data.data.data;

},
// ============================================================
// EXPENSE CATEGORIES
// ============================================================

async getExpenseCategories() {

  const { data } = await axiosClient.get(
    `${MASTER_URL}/expense-categories`
  );

  return data.data.data;

},
// ============================================================
// EXPENSE TYPES
// ============================================================

async getExpenseTypes() {

  const { data } = await axiosClient.get(
    `${MASTER_URL}/expense-types`
  );

   return data.data.data;

},
// ============================================================
// VENDORS
// ============================================================

async getVendors() {

  const { data } = await axiosClient.get(
    `${MASTER_URL}/vendors`
  );

  return data.data.data;

},
// ============================================================
// PROJECTS
// ============================================================

async getProjects() {

  const { data } = await axiosClient.get(
    `${MASTER_URL}/projects`
  );

  return data.data.data;

},
// ============================================================
// COST CENTERS
// ============================================================

async getCostCenters() {

  const { data } = await axiosClient.get(
     `${MASTER_URL}/cost-centers`
  );

  return data.data.data;

},
// ============================================================
// TAXES
// ============================================================

async getTaxes() {

  const { data } = await axiosClient.get(
    `${MASTER_URL}/taxes`
  );

  return data.data.data;

},
// ============================================================
// PAYMENT MODES
// ============================================================

async getPaymentModes() {

  const { data } = await axiosClient.get(
    `${MASTER_URL}/payment-mode`
  );

  return data.data.data;

},
// ============================================================
// RECEIPT TYPES
// ============================================================

async getReceiptTypes() {

  const { data } = await axiosClient.get(
     `${MASTER_URL}/receipt-types`
  );

  return data.data.data;

},


};


export default expenseClaimService;